import Toggle from 'react-toggle';
import './Toggle.css';

export const CustomToggle = ({ className, ...props }: any) => {
    return <Toggle {...props} icons={false} />;
};
